import { render } from "./PaginationComp.vue?vue&type=template&id=26ab731e&scoped=true&ts=true"
import script from "./PaginationComp.vue?vue&type=script&lang=ts"
export * from "./PaginationComp.vue?vue&type=script&lang=ts"

import "./PaginationComp.vue?vue&type=style&index=0&id=26ab731e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ab731e"]])

export default __exports__